/** Role filter for org admin members directory (client-only). */
export const MEMBERS_DIRECTORY_ROLE_FILTER = {
  ALL: 'ALL',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
} as const

export type MembersDirectoryRoleFilter =
  (typeof MEMBERS_DIRECTORY_ROLE_FILTER)[keyof typeof MEMBERS_DIRECTORY_ROLE_FILTER]

/** Sort order for org admin members directory (client-only). */
export const MEMBERS_DIRECTORY_SORT = {
  DEFAULT: 'DEFAULT',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  JOINED_NEWEST: 'JOINED_NEWEST',
  JOINED_OLDEST: 'JOINED_OLDEST',
} as const

export type MembersDirectorySortOption =
  (typeof MEMBERS_DIRECTORY_SORT)[keyof typeof MEMBERS_DIRECTORY_SORT]

export const ACCOUNT_MEMBERS_DIRECTORY_TEST_IDS = {
  SEARCH_INPUT: 'account-members-directory-search',
  FILTER_ALL: 'account-members-directory-filter-all',
  FILTER_ADMIN: 'account-members-directory-filter-admin',
  FILTER_MEMBER: 'account-members-directory-filter-member',
  SORT_DEFAULT: 'account-members-directory-sort-default',
  SORT_NAME_ASC: 'account-members-directory-sort-name-asc',
  SORT_NAME_DESC: 'account-members-directory-sort-name-desc',
  SORT_JOINED_NEWEST: 'account-members-directory-sort-joined-newest',
  SORT_JOINED_OLDEST: 'account-members-directory-sort-joined-oldest',
  RESULTS_SUMMARY: 'account-members-directory-results-summary',
} as const
